import React from 'react';
import { Property, AppUser } from '../../../types';
import { PropertyDetailView } from '../../../views/broker/PropertyDetailView';
import { SharePropertyModal } from '../../SharePropertyModal';
import { LeadCaptureModal } from '../../LeadCaptureModal';
import { MassShareModal } from '../MassShareModal';
import { BulkSelectionPayload } from '../../../server/bulk/bulkTypes';

interface BrokerModalsContainerProps {
  selectedPropertyDetail: Property | null;
  onClosePropertyDetail: () => void;
  propertyToShare: Property | null;
  onCloseShareProperty: () => void;
  interestedProperty: Property | null;
  onCloseInterested: () => void;
  isMassShareModalOpen: boolean;
  onCloseMassShare: () => void;
  selectionPayload: BulkSelectionPayload;
  selectedCount: number;
  appUser: AppUser | null;
  inmobiliariasConfig: Record<string, any>;
  updatePropertyLocally: (id: string, updates: any) => void;
  onViewProperty: (p: Property) => void;
  onShareProperty: (p: Property) => void;
}

export const BrokerModalsContainer: React.FC<BrokerModalsContainerProps> = ({
  selectedPropertyDetail,
  onClosePropertyDetail,
  propertyToShare,
  onCloseShareProperty,
  interestedProperty,
  onCloseInterested,
  isMassShareModalOpen,
  onCloseMassShare,
  selectionPayload,
  selectedCount,
  appUser,
  inmobiliariasConfig,
  updatePropertyLocally,
  onViewProperty,
  onShareProperty,
}) => {
  return (
    <>
      {selectedPropertyDetail && (
        <PropertyDetailView
          property={selectedPropertyDetail}
          onClose={onClosePropertyDetail}
          onShareProperty={onShareProperty}
          appUser={appUser}
          onPropertyUpdate={updatePropertyLocally}
          onViewProperty={onViewProperty}
          inmobiliariasConfig={inmobiliariasConfig}
        />
      )}

      {propertyToShare && (
        <SharePropertyModal
          property={propertyToShare}
          collectionName={(propertyToShare as any).sourceCollection}
          isOpen={!!propertyToShare}
          onClose={onCloseShareProperty}
          appUser={appUser}
        />
      )}

      {interestedProperty && (
        <LeadCaptureModal
          isOpen={!!interestedProperty}
          onClose={onCloseInterested}
          property={interestedProperty}
          appUser={appUser}
        />
      )}

      {isMassShareModalOpen && (
        <MassShareModal
          isOpen={isMassShareModalOpen}
          onClose={onCloseMassShare}
          selectionPayload={selectionPayload}
          selectedCount={selectedCount}
          appUser={appUser}
        />
      )}
    </>
  );
};
